import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white px-6 py-12 max-w-3xl mx-auto" data-testid="terms-page">
      <div className="mb-6">
        <Link to="/login" className="text-sm text-blue-600 hover:underline" data-testid="back-to-login-link">← Volver al inicio</Link>
      </div>
      <h1 className="text-3xl font-black text-[#111111] mb-2">Términos del Servicio</h1>
      <p className="text-sm text-[#52525B] mb-8">Última actualización: Abril 2026</p>

      <div className="space-y-6 text-sm text-[#333] leading-relaxed">
        <section>
          <p>
            Bienvenido a la plataforma de gestión de relaciones con el cliente (CRM) de <strong>Grupo Sach</strong> ("nosotros"). Al acceder y utilizar este servicio, usted acepta cumplir con estos Términos del Servicio. Si no está de acuerdo con alguna parte, por favor no utilice la plataforma.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">1. Descripción del Servicio</h2>
          <p>
            Grupo Sach ofrece una plataforma CRM interna para gestionar conversaciones, clientes, pedidos y catálogos de productos integrados con Facebook Messenger y WhatsApp Business API. La plataforma está destinada al uso exclusivo de empleados, agentes y administradores autorizados de la empresa.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">2. Cuentas de Usuario</h2>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Las cuentas son creadas únicamente por administradores autorizados de Grupo Sach.</li>
            <li>Cada usuario es responsable de mantener la confidencialidad de su contraseña.</li>
            <li>Las cuentas no son transferibles entre personas.</li>
            <li>El uso indebido de las credenciales será motivo de suspensión inmediata.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">3. Uso Permitido</h2>
          <p>El usuario se compromete a:</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Utilizar la plataforma exclusivamente para fines comerciales legítimos relacionados con la atención al cliente.</li>
            <li>No enviar contenido ilegal, ofensivo, fraudulento o que viole derechos de terceros.</li>
            <li>Cumplir con las políticas de Meta para Messenger y WhatsApp Business.</li>
            <li>No intentar acceder a información de otros usuarios o negocios sin autorización.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">4. Uso Prohibido</h2>
          <p>Está prohibido:</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>Enviar spam o mensajes no solicitados a clientes.</li>
            <li>Recopilar datos de clientes con fines distintos a los comerciales declarados.</li>
            <li>Vender, alquilar o transferir datos de clientes a terceros.</li>
            <li>Realizar ingeniería inversa, descompilar o intentar acceder al código fuente.</li>
            <li>Interferir con el funcionamiento normal de la plataforma.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">5. Propiedad Intelectual</h2>
          <p>
            Todo el contenido, diseño, código fuente, logotipos y marcas asociadas a la plataforma son propiedad de Grupo Sach. Los datos de los clientes (mensajes, pedidos) son propiedad de Grupo Sach con respeto a los derechos del titular de los datos según nuestra <Link to="/privacy" className="text-blue-600 underline">Política de Privacidad</Link>.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">6. Disponibilidad del Servicio</h2>
          <p>
            Hacemos esfuerzos razonables para mantener la plataforma disponible 24/7, pero no garantizamos un servicio ininterrumpido. Pueden ocurrir tiempos de inactividad por mantenimiento, actualizaciones o causas ajenas a nuestro control.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">7. Limitación de Responsabilidad</h2>
          <p>
            Grupo Sach no será responsable por daños indirectos, incidentales o consecuentes que resulten del uso o la imposibilidad de uso de la plataforma. La responsabilidad máxima total se limita al valor pagado por el servicio en los 12 meses anteriores al evento que originó el reclamo.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">8. Integración con Meta (Facebook y WhatsApp)</h2>
          <p>
            Esta plataforma utiliza las APIs oficiales de Meta. El uso de Facebook Messenger y WhatsApp Business está sujeto adicionalmente a:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li><a href="https://www.facebook.com/legal/terms" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Términos de Servicio de Facebook</a></li>
            <li><a href="https://www.whatsapp.com/legal/business-terms/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Términos Comerciales de WhatsApp Business</a></li>
            <li><a href="https://developers.facebook.com/devpolicy/" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">Políticas para Desarrolladores de Meta</a></li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">9. Terminación</h2>
          <p>
            Grupo Sach se reserva el derecho de suspender o terminar el acceso de cualquier usuario que viole estos términos, sin necesidad de notificación previa. El usuario puede solicitar la eliminación de su cuenta en cualquier momento contactando al administrador.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">10. Modificaciones</h2>
          <p>
            Podemos actualizar estos Términos del Servicio en cualquier momento. La fecha de "Última actualización" indica la versión vigente. El uso continuado de la plataforma después de los cambios constituye aceptación de los nuevos términos.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">11. Ley Aplicable</h2>
          <p>
            Estos términos se rigen por las leyes de la República de Guatemala. Cualquier disputa será resuelta en los tribunales competentes de Guatemala.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-bold text-[#111111] mb-2">12. Contacto</h2>
          <p>
            Para preguntas o consultas sobre estos términos:
          </p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li><strong>Empresa:</strong> Grupo Sach</li>
            <li><strong>Correo electrónico:</strong> <a href="mailto:complementossa@gmail.com" className="text-blue-600 underline">complementossa@gmail.com</a></li>
            <li><strong>Sitio web:</strong> <a href="https://crm.gruposach502.com" className="text-blue-600 underline">crm.gruposach502.com</a></li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
